import React from "react"
import { ResponsivePie } from "@nivo/pie"
import Tooltip from "./tooltip"
import { renderText } from "../Shared/utils"

interface PieProps {
	data: Array<any>
	colorPalette: any
}

const Pie: React.FC<PieProps> = ({ data, colorPalette }) => {
	return (
		<div style={{ height: "15rem" }}>
			<ResponsivePie
				data={data}
				startAngle={0}
				innerRadius={0.7}
				colors={colorPalette}
				sortByValue={true}
				borderWidth={0}
				padAngle={2}
				cornerRadius={5}
				enableArcLinkLabels={false}
				enableArcLabels={false}
				tooltip={({ datum }) => (
					<Tooltip
						indexValue={renderText(datum.id.toString())}
						data={datum.data}
						color={datum.color}
					/>
				)}
			/>
		</div>
	)
}

export default Pie
